import MuiDrawer from '@mui/material/Drawer';
import { alpha, CSSObject, Theme, styled } from '@mui/material/styles';
import { DRAWER_SIZE } from '../../const';

export const CustomDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: DRAWER_SIZE,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': {
        ...paperMixin(theme),
        ...openedMixin(theme),
      },
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': {
        ...paperMixin(theme),
        ...closedMixin(theme),
      },
    }),
  }),
);

const paperMixin = (theme: Theme): CSSObject => ({
  borderRight: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.08 : 0.6)}`,
  background:
    theme.palette.mode === 'dark'
      ? `linear-gradient(180deg, ${alpha('#07111d', 0.98)} 0%, ${alpha('#0a1523', 0.98)} 100%)`
      : `linear-gradient(180deg, ${alpha('#fbfdff', 0.98)} 0%, ${alpha('#edf4ff', 0.98)} 100%)`,
  boxShadow:
    theme.palette.mode === 'dark'
      ? `14px 0 34px ${alpha('#01050d', 0.2)}`
      : `10px 0 30px ${alpha('#aabed8', 0.12)}`,
  overflowX: 'hidden',
});

const openedMixin = (theme: Theme): CSSObject => ({
  width: DRAWER_SIZE,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
